import { Pipe, PipeTransform } from '@angular/core';
import { ConvertedIntentTopicInterface } from '../models/converted-intent-topic.interface';

@Pipe({
    name: 'topicsFilter',
    standalone: false
})
export class TopicsFilterPipe implements PipeTransform {
    transform(topics: ConvertedIntentTopicInterface[], searchValue: string, filterType: 'categories' | 'topics'): any {
        if (!searchValue?.length) {
            return topics;
        }
        const searchValueLowercase: string = searchValue.toLowerCase();

        if (filterType === 'categories') {
            const categoryTopicNames: string[] = [];
            return topics.filter((topic: ConvertedIntentTopicInterface) => {
                if (topic.category && topic.category.toLowerCase().includes(searchValueLowercase)) {
                    categoryTopicNames.push(...topic.topic_names);
                    return topic;
                }
                return categoryTopicNames.includes(topic.topic_name);
            });
        }

        return topics?.filter((topic: ConvertedIntentTopicInterface) => {
            if (topic.topic_name) {
                return topic.topic_name.toLowerCase().includes(searchValueLowercase);
            }
            return topic.topic_names?.some((name: string) => name.toLowerCase().includes(searchValueLowercase));
        })
    }
}
